import { render, staticRenderFns } from "./gameStat.vue?vue&type=template&id=329d7580&scoped=true&"
import script from "./gameStat.vue?vue&type=script&lang=js&"
export * from "./gameStat.vue?vue&type=script&lang=js&"
import style0 from "./gameStat.vue?vue&type=style&index=0&id=329d7580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d7580",
  null
  
)

export default component.exports